/**
 * Catálogo de Códigos CIE-10 (Clasificación Internacional de Enfermedades)
 * Enfocado en patologías prevalentes en Internación Domiciliaria
 */

export const CIE10_DOMICILIARIA = [
  // Neurología y ACV
  { code: 'I69.3', desc: 'Secuelas de infarto cerebral (ACV isquémico)', category: 'Neurología' },
  { code: 'I69.0', desc: 'Secuelas de hemorragia subaracnoidea', category: 'Neurología' },
  { code: 'G30.9', desc: 'Enfermedad de Alzheimer, no especificada', category: 'Neurología' },
  { code: 'F03', desc: 'Demencia senil no especificada', category: 'Neurología / Salud Mental' },
  { code: 'G20', desc: 'Enfermedad de Parkinson', category: 'Neurología' },
  { code: 'G12.2', desc: 'Enfermedad de la motoneurona (ELA - Esclerosis Lateral Amiotrófica)', category: 'Neurología' },
  { code: 'G82.2', desc: 'Paraplejía, no especificada', category: 'Neurología' },
  { code: 'G82.5', desc: 'Cuadriplejía, no especificada', category: 'Neurología' },

  // Respiratorio
  { code: 'J44.9', desc: 'Enfermedad pulmonar obstructiva crónica (EPOC), no especificada', category: 'Neumonología' },
  { code: 'J96.1', desc: 'Insuficiencia respiratoria crónica con dependencia de oxígeno', category: 'Neumonología' },
  { code: 'J18.9', desc: 'Neumonía, no especificada (adquirida en la comunidad / aspirativa)', category: 'Neumonología' },
  { code: 'Z99.1', desc: 'Dependencia de respirador mecánico (ARM domiciliario)', category: 'Soporte Vital' },
  { code: 'Z93.0', desc: 'Traqueostomía (Mantenimiento y aspiración)', category: 'Soporte Vital' },

  // Cardiovascular
  { code: 'I50.9', desc: 'Insuficiencia cardíaca congestiva crónica', category: 'Cardiología' },
  { code: 'I10', desc: 'Hipertensión esencial (primaria)', category: 'Cardiología' },
  { code: 'I70.2', desc: 'Aterosclerosis de las arterias de los miembros (Isquemia crítica)', category: 'Vascular' },

  // Dermatología, Heridas y Cirugía
  { code: 'L89.1', desc: 'Úlcera por presión (UPP) de región sacra, Estadío II/III', category: 'Heridas Complejas' },
  { code: 'L89.2', desc: 'Úlcera por presión (UPP) de trocánter / cadera', category: 'Heridas Complejas' },
  { code: 'L89.3', desc: 'Úlcera por presión (UPP) de talón / maleolar', category: 'Heridas Complejas' },
  { code: 'E11.5', desc: 'Diabetes mellitus tipo 2 con complicaciones circulatorias periféricas (Pie diabético)', category: 'Metabólico / Heridas' },
  { code: 'T81.4', desc: 'Infección consecutiva a procedimiento quirúrgico (Dehiscencia de herida)', category: 'Quirúrgico' },

  // Traumatología y Rehabilitación
  { code: 'S72.0', desc: 'Fractura del cuello del fémur (Post-quirúrgico de cadera)', category: 'Traumatología' },
  { code: 'M16.9', desc: 'Coxartrosis / Reemplazo total de cadera', category: 'Traumatología' },
  { code: 'M17.9', desc: 'Gonartrosis / Reemplazo de rodilla', category: 'Traumatología' },
  { code: 'Z96.6', desc: 'Presencia de implantes ortopédicos articulares', category: 'Traumatología' },

  // Cuidados Paliativos y Oncología
  { code: 'Z51.5', desc: 'Atención médica para cuidados paliativos (Terapia del dolor)', category: 'Cuidados Paliativos' },
  { code: 'C34.9', desc: 'Tumor maligno de los bronquios o del pulmón', category: 'Oncología' },
  { code: 'C18.9', desc: 'Tumor maligno del colon', category: 'Oncología' },
  { code: 'C50.9', desc: 'Tumor maligno de la mama', category: 'Oncología' },

  // Nefrología y Soporte Nutricional
  { code: 'N18.5', desc: 'Enfermedad renal crónica, etapa 5 (Diálisis peritoneal domiciliaria)', category: 'Nefrología' },
  { code: 'Z93.1', desc: 'Gastrostomía (Soporte nutricional enteral K-108 / PEG)', category: 'Nutrición / Soporte' },
  { code: 'Z93.6', desc: 'Otros orificios artificiales de las vías urinarias (Talla vesical)', category: 'Urología' }
];

export function buscarCIE10(termino) {
  if (!termino || termino.trim() === '') return CIE10_DOMICILIARIA.slice(0, 8);
  const q = termino.toLowerCase().trim();
  return CIE10_DOMICILIARIA.filter(item => 
    item.code.toLowerCase().includes(q) || 
    item.desc.toLowerCase().includes(q) ||
    item.category.toLowerCase().includes(q)
  );
}
